import { Provider, useAtom } from "jotai";
import { useContext } from "react";
import tools from "../../../../../helpers/tools";
import AssignationLead from "../../../../common/CarteLead/AssignationLead";
import { FORMAT_LONG } from "../../../../common/CarteLead/MetaCarte";
import PanneauLead from "../../../../common/CarteLead/PanneauLead";
import ProduitLead from "../../../../common/CarteLead/ProduitLead";
import Puce from "../../../../common/CarteLead/Puce";
import StatutLead from "../../../../common/CarteLead/StatutLead";
import CommentList from "../../../../common/CommentList/CommentList";
import TodoList from "../../../../common/TodoList/TodoList";
import { nomDuLead, PRODUIT_AUTO } from "../carte/EnTeteLead";
import { extrasPanneau } from "../carte/extrasOnglets";
import { progressionDemande } from "../carte/progressionDemande";
import { agentTimelineAtom } from "../LeadAutoAgent/agentTimelineAtom";
import LeadAutoAgentTimeline from "../LeadAutoAgent/LeadAutoAgentTimeline";
import LeadAutoInfosPanel from "../LeadAutoInfosPanel/LeadAutoInfosPanel";
import { LeadAutoItemContext } from "../LeadAutoItemContext";
import LeadAutoRetranscription from "../LeadAutoRetranscription/LeadAutoRetranscription";
import useLeadAutoItem from "../useLeadAutoItem";

// Panneau de détail d'un lead auto : le panneau du kit commun avec la ligne
// d'état (statut, assignation, avancement) et le contenu existant de chaque
// section (infos et documents, commentaires, tâches, agent, retranscription).
const PanneauLeadAuto = ({ canCommand, ton = "primary" }) => {
  const { leadAutoItem, actions } = useLeadAutoItem();
  const { tasksByProduct, managers, contacts, panneau } = useContext(LeadAutoItemContext);
  const progression = progressionDemande(leadAutoItem);
  // Timeline de l'agent chargée par l'onglet : le point de l'onglet « Agent » se complète de « 2 compagnies » s'il y a lieu (PER-2500).
  const [agentTimeline] = useAtom(agentTimelineAtom);

  const contenu = (onglet) => {
    switch (onglet) {
      case "commentaires":
        return (
          <Provider>
            <CommentList
              initComments={leadAutoItem.comments || []}
              onUpdateComments={actions.onUpdateComments}
              onUpdateComment={actions.onUpdateComment}
              onAddComment={actions.onAddComment}
              onDeleteComment={actions.onDeleteComment}
              users={contacts}
            />
          </Provider>
        );
      case "taches":
        return (
          <Provider>
            <TodoList
              initTodos={leadAutoItem.tasks || []}
              tasksByProduct={tasksByProduct}
              onUpdateTodos={actions.onUpdateTasks}
              onUpdateTodo={actions.onUpdateTask}
              onAddTodo={actions.onAddTask}
              onDeleteTodo={actions.onDeleteTask}
              users={managers}
            />
          </Provider>
        );
      case "agent":
        return <LeadAutoAgentTimeline leadAutoItem={leadAutoItem} onRefreshLead={actions.refreshLead} canCommand={canCommand} />;
      case "retranscription":
        return <LeadAutoRetranscription retranscriptions={leadAutoItem.retranscriptions} />;
      case "infos":
      default:
        return <LeadAutoInfosPanel leadData={leadAutoItem} />;
    }
  };

  return (
    <PanneauLead
      idCarte={`leadautoitem${leadAutoItem.id}`}
      leadId={leadAutoItem.id}
      panneau={panneau}
      ton={ton}
      produit={<ProduitLead {...PRODUIT_AUTO} petit />}
      titre={nomDuLead(leadAutoItem)}
      sousTitre={`Lead auto · créé le ${tools.formatDate(leadAutoItem.createdAt, FORMAT_LONG)}`}
      etat={
        <>
          <StatutLead lead={leadAutoItem} onUpdateStatus={actions.onUpdateStatus} portee="panneau" />
          <AssignationLead
            leadId={leadAutoItem.id}
            assignedTo={leadAutoItem.assignedTo}
            managers={managers}
            onAssigner={actions.onUpdateAssignTo}
            portee="panneau"
          />
          <Puce ton={progression.ton} icone={progression.icone} titre={progression.description}>
            {progression.libelle}
          </Puce>
        </>
      }
      extra={extrasPanneau(leadAutoItem, agentTimeline)}
      contenu={contenu}
    />
  );
};

export default PanneauLeadAuto;
